var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentHorizontalCenterSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11C12.5 11.2761 12.2761 11.5 12 11.5H2C1.72386 11.5 1.5 11.2761 1.5 11C1.5 10.7239 1.72386 10.5 2 10.5H12C12.2761 10.5 12.5 10.7239 12.5 11Z",
    fill: "#181038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 1C13.5 1.27614 13.2761 1.5 13 1.5H1C0.72386 1.5 0.5 1.27614 0.5 1C0.5 0.72386 0.72386 0.5 1 0.5H13C13.2761 0.5 13.5 0.72386 13.5 1Z",
    fill: "#181038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6C10.5 6.27615 10.2761 6.5 10 6.5H4C3.72385 6.5 3.5 6.27615 3.5 6C3.5 5.72385 3.72385 5.5 4 5.5H10C10.2761 5.5 10.5 5.72385 10.5 6Z",
    fill: "#181038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentHorizontalCenterSmall);
export default __webpack_public_path__ + "static/media/alignment-horizontal-center-small.31a69ecbd11ff402e3fb00e446464433.svg";
export { ForwardRef as ReactComponent };